import { paginationOptions, navigationOptions } from "Config/slider/default"
import { productsSliderOptions } from "Config/slider/product"

import { rSwiperVisibleItems } from 'Functions/swiper-visible-items'
import { rSwiperCssNavFix } from 'Functions/swiper-css-nav-fix'
import {Pagination, Navigation, EffectFade, Autoplay} from 'swiper';
import { loginSliderOptions } from "Config/slider/login";
import { indexBannerSliderOptions } from "Config/slider/index-banner";

export const sliderOptions = instance => {
    // default options
    let options = {
        simulateTouch: false,
        watchOverflow: true,
        preventInteractionOnTransition: true,
        roundLengths: true,
        modules: [Pagination, Navigation, rSwiperVisibleItems, rSwiperCssNavFix, EffectFade, Autoplay]
    }

    if (instance.paginationEl) {
        options = {...options, ...paginationOptions(instance)}
    }

    if (instance.prevEl && instance.nextEl) {
        options = {...options, ...navigationOptions(instance)}
    }

    if (instance.hasAttribute('r-slider-products')) {
        const maxVisibleItems = instance.hasAttribute('r-max-visible-items') ? instance.getAttribute('r-max-visible-items') : 10
        const spaceBetween = instance.hasAttribute('r-space-between') ? instance.getAttribute('r-space-between') : 0
        options = {...options, ...productsSliderOptions(instance, options, maxVisibleItems, spaceBetween)}
    }

    if (instance.hasAttribute('r-slider-login')) {
        options = {...options, ...loginSliderOptions(instance, options)}
    }

    if (instance.hasAttribute('r-slider-index-banner')) {
        options = {...options, ...indexBannerSliderOptions(instance, options, instance.labels)}
    }

    return {...options, ...instance.customOptions}
}